export default {
  'processes.form.instancesNamePattern': 'Patrón Nombre Solicitudes',
  'processes.form.instancesNamePattern.acnRequired':
    'El patrón debe incluir un token de número automático ({ACNI#n}, {ACNY#n}, {ACNM#n} o {ACND#n}).',
  'processes.form.instancesNamePattern.periodIdentity':
    'Los patrones anuales, mensuales y diarios requieren tokens de fecha coincidentes (año / mes / día).',
  'processes.form.lastGeneratedNumber': 'Último Número Generado',
  'processes.instanceNumbering.title': 'Patrón de Nombres',
  'processes.instanceNumbering.description':
    'Administra el patrón de nombre de solicitudes y el último número generado de este proceso.',
  'processes.instanceNumbering.descriptionNamed':
    'Administra el patrón de nombre de solicitudes y el último número generado de {name}.',
  'processes.instanceNumbering.periodKind': 'Tipo de periodo',
  'processes.instanceNumbering.periodKind.continuous': 'Continuo',
  'processes.instanceNumbering.periodKind.yearly': 'Anual',
  'processes.instanceNumbering.periodKind.monthly': 'Mensual',
  'processes.instanceNumbering.periodKind.daily': 'Diario',
  'processes.instanceNumbering.lastAllocatedAt': 'Última asignación',
  'processes.instanceNumbering.lgnCannotDecrease':
    'El último número generado no se puede disminuir mientras el tipo de periodo no cambie.',
  'processes.instanceNumbering.confirmPeriodChange.title': '¿Cambiar el tipo de periodo?',
  'processes.instanceNumbering.confirmPeriodChange.content':
    'Cambiar el tipo de periodo puede reiniciar el correlativo a 0 y limpiar los contadores de periodo. ¿Continuar?',
  'processes.form.isNotificationsEnabled': '¿Notificaciones Habilitadas?',
  'processes.form.notificationsFrequency': 'Frecuencia de Notificaciones',
  'processes.form.notificationsFrequencyValue': 'Valor Frecuencia Notificaciones',
  'processes.form.startMode': 'Modo de inicio',
  'processes.form.startFrequency': 'Frecuencia Inicio',
  'processes.form.startFrequencyValue': 'Valor Frecuencia Inicio',
  'processes.form.startDate': 'Fecha Inicio',
  'processes.form.lastStartDate': 'Última Fecha Iniciado',
  'processes.form.isDeadlineEnabled': '¿Habilitar Control de Limite de Tiempo de Ejecucion?',
  'processes.form.deadlineMeasureUnit': 'Unidad de Control de Tiempo',
  'processes.form.deadlineMeasureValue': 'Valor de Control de Tiempo',

  'processes.form.isRequestsLimitEnabled': '¿Controlar Cantidad de Solicitudes Permitidas?',
  'processes.form.requestsLimit': 'Cantidad de Solicitudes Permitidas',
  'processes.form.maxRejectionCount': 'Máximo Número de Rechazos',
  'processes.form.disableSendApprovedRequestMailAtEnd':
    'Deshabilitar Envío de Correo de Solicitud Aprobada al Final',
  'processes.form.disableSendRejectedRequestMailAtEnd':
    'Deshabilitar Envío de Correo de Solicitud Rechazada al Final',
  'processes.form.isSendErrorNotificationsEnabled': '¿Habilitar Notificaciones de Error?',
  'processes.form.isBulkRequestCreationEnabled': '¿Habilitar Creación Masiva de Solicitudes?',
  'processes.form.isAllowViewWithoutAuthenticatingEnabled':
    '¿Permitir Visualización Sin Autenticación?',
  'processes.form.isAllowApprovalWithoutAuthenticatingEnabled':
    '¿Permitir Aprobación Sin Autenticación?',
  'processes.form.disableRequestCancellation': 'Deshabilitar Cancelación de Solicitudes',
  'processes.form.commentsAccessMode': 'Modo de Acceso a Comentarios',
  'processes.form.commentsAccessMode.disabled': 'Deshabilitado',
  'processes.form.commentsAccessMode.readOnly': 'Solo lectura',
  'processes.form.commentsAccessMode.appendOnly': 'Solo agregar (sin editar ni eliminar)',
  'processes.form.commentsAccessMode.delete': 'Solo eliminar (moderación)',
  'processes.form.commentsAccessMode.edit': 'Editar (sin eliminar)',
  'processes.form.commentsAccessMode.editAndDelete': 'Editar y eliminar',
  'processes.form.isShowPercentEnabled': '¿Mostrar Porcentaje de Progreso?',
  'processes.form.percentActionFilters': '% / Tipos de Acción',
  'processes.form.offlineEnabled': 'Habilitar Modo Offline',

  // Wizard Steps
  'processes.wizard.steps.basicInformation': 'Información Básica',
  'processes.wizard.steps.namePatterns': 'Patrones de Nombres',
  'processes.wizard.steps.notificationSettings': 'Configuración de Notificaciones',
  'processes.wizard.steps.startMode': 'Modo de Inicio',
  'processes.wizard.steps.requestsLimitDeadline': 'Límites y Plazos',
  'processes.wizard.steps.others': 'Otras Configuraciones',
  'processes.wizard.stepProgress': 'Paso {current} de {total}',

  'processes.select.instant': 'Flujo Manual',
  'processes.select.automated': 'Flujo Automatizado',
  'processes.select.scheduled': 'Flujo Programado',

  'processes.configure.title': 'Configurar Proceso',
  'process.SearchInput.placeholder': 'Buscar Configuración',

  'process.text.fileName': 'Nombre',
  'process.text.userCreator': 'Autor',
  'process.text.contentType': 'Tipo de Archivo',
  'process.text.options': 'Opciones',
  'process.text.processPortal': 'Portal de Procesos',
  'process.text.completed': 'Ejecutado',
  'process.text.manually': 'Manual',
  'process.text.automatic': 'Automático',
  'process.text.schedule': 'Programado',

  'process.text.reportName': 'Nombre',
  'process.text.reportType': 'Tipo',
  'process.text.listName': 'Nombre',
  'process.text.listType': 'Tipo',
  'process.text.portalName': 'Nombre',
  'process.text.portalCode': 'Code',

  'process.button.bulk.upload': 'Cargar formato Excel Solicitudes',
  'process.button.bulk.label': 'Haz clic para cargar',

  'process.text.bulk.download': 'Descargar plantilla de carga masiva',
  'process.text.bulk.upload': 'Carga masiva de solicitudes',
  'process.text.bulk.isScheduledProcessingEnabled': '¿Habilitar Fecha de Procesamiento Programada?',
  'process.text.bulk.attachments': 'Documento Excel',
  'process.text.bulk.scheduledProcessingDate': 'Fecha de Procesamiento Programada',
  'process.text.bulk.download.loading': 'Descargando Plantilla de Solicitudes...',
  'process.text.bulk.download.success': 'Plantilla de Solicitudes descargado correctamente.',

  'process.text.reports.reportType1': 'Administración',
  'process.text.reports.reportType2': 'Procesos',
  'process.text.reports.reportType3': 'Solicitud',
  'process.text.reports.reportType4': 'Genérico',
  'process.text.reports.reportType5': 'Conector PowerBI',

  'process.text.lists.listType1': 'Lista',
  'process.text.lists.listType2': 'Gant',
  'process.text.lists.listType3': 'Calendario',
  'process.text.lists.listType4': 'Tareas',
  'process.text.lists.listType6': 'Tarjetas',
  'process.text.lists.listType7': 'Mapa',
  'process.canvas.note.placeholder': 'Como una nota...',
  'process.approval.card.general.description': 'Configuración general de aprobación',
  'process.approval.card.rejection.description': 'Configuración de rechazo y control de rechazos',
  'process.approval.card.deadline.description': 'Control de límite de tiempo de ejecución',
  'process.approval.card.filters.general.description':
    'Configuración general de filtros de aprobadores',
  'process.approval.card.filters.users.description': 'Filtrar aprobadores por usuarios específicos',
  'process.approval.card.filters.positions.description': 'Filtrar aprobadores por puestos',
  'process.approval.card.filters.areas.description': 'Filtrar aprobadores por áreas',
  'process.approval.card.filters.userGroups.description':
    'Filtrar aprobadores por grupos de usuarios',
  'process.approval.card.filters.externalUsers.description':
    'Filtrar aprobadores por usuarios externos',
  'process.approval.card.filters.agents.description': 'Filtrar aprobadores por agentes IA',
  'process.approval.card.filters.userExtraFields.description':
    'Filtrar aprobadores por campos extra de usuario',
  'process.approval.card.filters.global.description':
    'Configurar filtros globales de aprobadores (7 sub-grupos)',
  'process.approval.card.filters.formField.description':
    'Filtrar aprobadores por campos de formulario (4 sub-grupos)',
  'process.approval.filters.externalUsers.alert.title': 'Configuración simplificada',
  'process.approval.filters.externalUsers.alert.description':
    'Esta es una versión simplificada que maneja un único filtro de usuario externo. Para la gestión completa de múltiples elementos, usa la implementación con lista y drawer.',
  'process.approval.filters.userExtraFields.alert.title': 'Configuración simplificada',
  'process.approval.filters.userExtraFields.alert.description':
    'Esta es una versión simplificada que maneja un único filtro de campo extra de usuario. Para la gestión completa de múltiples elementos, usa la implementación con lista y drawer.',

  'process.v1ConfigURL.noURL': 'No se proporcionó URL de configuración',

  // Form List
  'form.title': 'Listado de Formularios',
  'config.searchForm': 'Buscar formulario',

  // Form Canvas
  'config.form.canvas.creation': 'Creación de Formulario',
  'config.form.canvas.configuration': 'Configuración',
  'config.form.canvas.preview': 'Vista Previa',
  'config.form.canvas.confirm': 'Confirmar',
  'config.form.canvas.searchComponent': 'Busca un componente',

  // Secciones del panel
  'config.form.canvas.section.layout': 'Diseño',
  'config.form.canvas.section.text': 'Texto',
  'config.form.canvas.section.numbers': 'Números',
  'config.form.canvas.section.datetime': 'Fecha y Hora',
  'config.form.canvas.section.selection': 'Selección',
  'config.form.canvas.section.files': 'Archivos y Medios',
  'config.form.canvas.section.people': 'Personas',
  'config.form.canvas.section.data': 'Fuentes de Datos',
  'config.form.canvas.section.advanced': 'Avanzado',

  // Diseño
  'config.form.canvas.component.group': 'Sección',
  'config.form.canvas.component.divider': 'Divisor',

  // Texto
  'config.form.canvas.component.text': 'Texto Corto',
  'config.form.canvas.component.textMultiple': 'Texto Largo',
  'config.form.canvas.component.email': 'Correo',
  'config.form.canvas.component.url': 'URL',
  'config.form.canvas.component.password': 'Contraseña',

  // Números
  'config.form.canvas.component.integer': 'Entero',
  'config.form.canvas.component.decimal': 'Decimal',
  'config.form.canvas.component.slider': 'Deslizador',

  // Fecha y Hora
  'config.form.canvas.component.date': 'Fecha',
  'config.form.canvas.component.dateTime': 'Fecha y Hora',
  'config.form.canvas.component.time': 'Hora',

  // Selección
  'config.form.canvas.component.choice': 'Desplegable',
  'config.form.canvas.component.radioGroup': 'Grupo Radio',
  'config.form.canvas.component.checkGroup': 'Grupo Check',
  'config.form.canvas.component.boolean': 'Toggle / Switch',

  // Archivos y Medios
  'config.form.canvas.component.attachment': 'Adjunto',
  'config.form.canvas.component.image': 'Imagen',
  'config.form.canvas.component.photo': 'Foto',
  'config.form.canvas.component.signature': 'Firma',

  // Personas
  'config.form.canvas.component.selectorUser': 'Usuario',
  'config.form.canvas.component.selectorPosition': 'Posición',
  'config.form.canvas.component.selectorUserGroup': 'Grupo de Usuarios',
  'config.form.canvas.component.selectorArea': 'Área',

  // Fuentes de Datos
  'config.form.canvas.component.dbRemoteSearch': 'Búsqueda BD',
  'config.form.canvas.component.dbRemoteList': 'Lista BD',
  'config.form.canvas.component.wsRemoteSearch': 'Búsqueda WS',
  'config.form.canvas.component.wsRemoteList': 'Lista WS',
  'config.form.canvas.component.entityList': 'Lista Entidad',
  'config.form.canvas.component.entitySearch': 'Búsqueda Entidad',

  // Avanzado
  'config.form.canvas.component.table': 'Tabla',
  'config.form.canvas.component.formula': 'Fórmula',
  'config.form.canvas.component.autoCalc': 'Cálculo Auto',
  'config.form.canvas.component.goToAction': 'Ir a Acción',
  'config.form.canvas.component.location': 'Ubicación',
  'config.form.canvas.component.likert': 'Escala Likert',

  // Etiquetas del canvas
  'config.form.canvas.dropGroup': 'Suelta aquí para agregar una sección',
  'config.form.canvas.dropElement': 'Suelta aquí para agregar un elemento',

  // Form Configuration Layout
  'config.form.config.addField': 'Agregar Campo',
  'config.form.config.unnamedSection': 'Sección sin título',
  'config.form.config.groupLabel': 'Grupo',
  'config.form.config.dropField': 'Suelta aquí para agregar campo',
  'config.form.config.delete': 'Eliminar',
  'config.form.config.expand': 'Extender',
  'config.form.config.contract': 'Contraer',
  'config.form.config.edit': 'Editar',
  'config.form.config.fieldPlaceholder': 'Ingresa un valor',
  'config.form.config.header.label': 'Encabezado',
  'config.form.config.uploadDragText': 'Arrastre y suelte un archivo aquí o haga clic',
  'config.form.config.drawer.field.title': 'Configuración del Campo',
  'config.form.config.drawer.section.title': 'Configuración de Sección',
  'config.form.config.drawer.general': 'General',
  'config.form.config.drawer.behavior': 'Comportamiento',
  'config.form.config.drawer.displayText': 'Etiqueta del Campo',
  'config.form.config.error.listRequired': 'Agrega al menos una opción.',
  'config.form.config.error.listDuplicate': 'Las opciones no pueden repetirse.',
  'config.form.config.error.minMax': 'El máximo debe ser mayor o igual que el mínimo.',
  'config.form.config.filter.title': 'Filtros',
  'config.form.config.filter.item': 'Filtro',
  'config.form.config.filter.add': 'Agregar filtro',
  'config.form.config.filter.valueSource': 'Origen del valor',
  'config.form.config.filter.source.formField': 'Campo de formulario',
  'config.form.config.filter.source.variable': 'Variable',
  'config.form.config.filter.source.formula': 'Fórmula',
  'config.form.config.filter.source.fixedValue': 'Valor fijo',
  'config.form.config.filter.source.internalField': 'Campo interno',
  'config.form.config.filter.sourceForm': 'Formulario origen',
  'config.form.config.filter.sourceField': 'Campo origen',
  'config.form.config.filter.sourceVariable': 'Variable origen',
  'config.form.config.filter.formula': 'Fórmula',
  'config.form.config.filter.fixedValue': 'Valor fijo',
  'config.form.config.filter.internalField': 'Campo interno',
  'config.form.config.filter.parameterName': 'Nombre de parámetro',
  'config.form.config.filter.comparisonOperator': 'Operador de comparación',
  'config.form.config.filter.required': '¿Requerido?',
  'config.form.config.drawer.helpText': 'Texto de Ayuda',
  'config.form.config.drawer.required': '¿Requerido?',
  'config.form.config.drawer.enabled': '¿Elemento Habilitado?',
  'config.form.config.drawer.readOnly': '¿Solo Lectura?',
  'config.form.config.drawer.hidden': '¿Oculto?',
  'config.form.config.drawer.sectionTitle': 'Título de Sección',
  'config.form.config.drawer.sectionDescription': 'Descripción de Sección',
  'config.form.config.drawer.internalName': 'Nombre Interno',

  // Drawer — configuración del campo
  'config.form.config.drawer.settings': 'Configuración del Campo',
  'config.form.config.drawer.defaultValue': 'Valor por Defecto',
  'config.form.config.drawer.formula': 'Fórmula',
  'config.form.config.drawer.choices': 'Opciones (una por línea)',
  'config.form.config.drawer.minLength': 'Longitud Mínima',
  'config.form.config.drawer.maxLength': 'Longitud Máxima',
  'config.form.config.drawer.minValue': 'Valor Mínimo',
  'config.form.config.drawer.maxValue': 'Valor Máximo',
  'config.form.config.drawer.decimalPlaces': 'Decimales',
  'config.form.config.drawer.format': 'Formato',
  'config.form.config.drawer.allowMultiple': 'Permitir Múltiples',
  'config.form.config.drawer.autoSelect': 'Seleccionar Primero Automáticamente',
  'config.form.config.drawer.allowInsertNewOption': 'Permitir Nuevas Opciones',
  'config.form.config.drawer.scannerEnabled': 'Escáner Habilitado',
  'config.form.config.drawer.currentDateDefault': 'Fecha Actual por Defecto',
  'config.form.config.drawer.currentDateTimeDefault': 'Fecha y Hora Actual por Defecto',
  'config.form.config.drawer.currentTimeDefault': 'Hora Actual por Defecto',
  'config.form.config.drawer.maxFileSize': 'Tamaño Máximo (MB)',
  'config.form.config.drawer.minAttachments': 'Mínimo de Archivos',
  'config.form.config.drawer.maxAttachments': 'Máximo de Archivos',
  'config.form.config.drawer.step': 'Paso',
  'config.form.config.drawer.textFormat': 'Formato de Texto',
  'config.form.config.drawer.textFormat.plainText': 'Texto Plano',
  'config.form.config.drawer.textFormat.richText': 'Texto Enriquecido',
  'config.form.config.drawer.orderDirection': 'Orden',
  'config.form.config.drawer.orderDirection.ascending': 'Ascendente',
  'config.form.config.drawer.orderDirection.descending': 'Descendente',
  'config.form.config.drawer.groupingType': 'Tipo de Agrupación',
  'config.form.config.drawer.groupingType.none': 'Ninguno',
  'config.form.config.drawer.groupingType.value': 'Por Valor',
  'config.form.config.drawer.groupingType.displayText': 'Por Texto',
  'config.form.config.drawer.currentUser': 'Usuario Actual por Defecto',
  'config.form.config.drawer.currentUserPosition': 'Posición Actual por Defecto',
  'config.form.config.drawer.currentUserUserGroups': 'Grupos Actuales por Defecto',
  'config.form.config.drawer.currentUserArea': 'Área Actual por Defecto',
  'config.form.config.drawer.isCurrentUserLocationEnabled': 'Ubicación Actual por Defecto',
  'config.form.config.drawer.mathOperation': 'Operación Matemática',
  'config.form.config.drawer.mathOperation.sum': 'Suma',
  'config.form.config.drawer.mathOperation.avg': 'Promedio',
  'config.form.config.drawer.mathOperation.count': 'Conteo',
  'config.form.config.drawer.mathOperation.min': 'Mínimo',
  'config.form.config.drawer.mathOperation.max': 'Máximo',
  'config.form.config.drawer.observations': 'Notas / Observaciones',
  'config.form.config.drawer.visibleInDetails': 'Visible en Detalles',
  'config.form.config.drawer.columnWidth': 'Ancho de Columna',
  'config.form.config.drawer.order': 'Orden',
  'config.form.config.columnWidth.extraSmall': 'Extra Pequeño',
  'config.form.config.columnWidth.small': 'Pequeño',
  'config.form.config.columnWidth.medium': 'Mediano',
  'config.form.config.columnWidth.large': 'Grande (Ancho Completo)',

  // Form Config
  'config.form.tab.form': 'Formulario',
  'config.form.tab.formConfig': 'Configuraciones',
  'config.form.tab.formStyle': 'Estilos',
  'config.form.tab.formPublicStyle': 'Estilo Formulario Publico',
  'config.form.title': 'Título',
  'config.form.header.text': 'Descripción',
  'config.form.header.image': 'Imagen de Cabecera',
  'config.form.wizardOrientation': 'Wizard / Orientación',
  'config.form.wizardOrientation.horizontal': 'Horizontal',
  'config.form.wizardOrientation.vertical': 'Vertical',
  'config.form.wizardStepStyle': 'Wizard / Estilo',
  'config.form.wizardStepStyle.stepNumber': 'Número de paso',
  'config.form.wizardStepStyle.progressBar': 'Barra de progreso',
  'config.form.formSendRequestButtonText': 'Texto Botón Enviar',
  'config.form.visibleInDetails': '¿Visible en Vista Detalles?',
  'config.form.externalViewEnabled': '¿Vista Externa Habilitada?',
  'config.form.externalViewDetailsTabVisible': '¿Vista Externa / Tab Detalles Visible?',
  'config.form.externalViewGeneratedDocumentsTabVisible':
    '¿Vista Externa / Tab Documentos Generados Visible?',
  'config.form.externalViewDocumentsTabVisible': '¿Vista Externa / Tab Documentos Visible?',
  'config.form.hideSaveButton': '¿Ocultar Botón Guardar?',
  'config.form.hideCancelButton': '¿Ocultar Botón Cancelar?',
  'config.form.style.template': 'Plantilla',
  'config.form.style.template.default': 'Por defecto',
  'config.form.style.mainColor': 'Color Principal',
  'config.form.style.logoUrl': 'Url Logo',
  'config.form.style.fontUrl': 'Url Fuente',
  'config.form.publicStyle.template': 'Plantilla',
  'config.form.publicStyle.template.basic': 'Básico',
  'config.form.publicStyle.template.basicBanner': 'Básico con banner',
  'config.form.publicStyle.mainColor': 'Color Principal',
  'config.form.publicStyle.logoUrl': 'Url Logo',
  'config.form.publicStyle.fontUrl': 'Url Fuente',
};
